(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/views/welcome.js') >= 0) return;  svs.modules.push('/modules/maltipset/views/welcome.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.maltipset=_svs.maltipset||{};
_svs.maltipset.templates=_svs.maltipset.templates||{};
svs.maltipset.templates.welcome = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"startcomponentregion\"></div>";
},"useData":true});
Handlebars.partials['svs-maltipset-welcome'] = svs.maltipset.templates.welcome;
})(svs, Handlebars);

 })(window);